module.exports = __webpack_public_path__ + "static/img/vip2.299bd7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vip2.png
// module id = C6Lf
// module chunks = 1